import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Ist dieses eBook wirklich für absolute Anfänger?',
  a: 'Ja. Das K-Visual Masterplan™-System ist für Menschen konzipiert, die noch nie Koreanisch oder eine andere Sprache studiert haben. Wir beginnen mit dem Alphabet und bauen alles Schritt für Schritt auf.'
}, {
  q: 'Kann ich lernen, auch wenn ich keine gute Sprachbasis habe?',
  a: 'Absolut. Dieses System wurde speziell für Menschen entwickelt, die denken, sie seien „nicht gut in Sprachen“. Die visuelle Methode macht alles zugänglich und macht Spaß.'
}, {
  q: 'Sind die Ausdrücke und Sätze wirklich nützlich?',
  a: 'Ja. Jeder Satz und Ausdruck wurde aus echten K-Dramen und von echten Koreanern extrahiert. Du lernst Sprache, die Menschen wirklich verwenden, nicht nur Schulbuchbeispiele.'
}, {
  q: 'Enthält das eBook Tipps zur Aussprache und zum Vermeiden von Fehlern?',
  a: 'Ja. Wir enthalten Audio-Beispiele von nativen Koreanern, Tipps zur Vermeidung von Fehlern, die Deutschsprachige typischerweise machen, und genaue Anleitungen zur korrekten Aussprache.'
}, {
  q: 'Wann sehe ich echte Fortschritte?',
  a: 'Die meisten Menschen sehen Fortschritte ab Tag 1. Sie können bereits Hangeul lesen. Um in echten Gesprächen zu sprechen, werden 60 Tage empfohlen, aber die meisten Schüler berichten von spürbarem Fortschritt bereits in Woche 1.'
}, {
  q: 'Brauche ich andere Apps oder kann ich nur dieses System verwenden?',
  a: 'Du kannst dieses System allein verwenden. Es ist komplett in sich geschlossen. Wenn du andere Apps verwenden möchtest, funktioniert es auch gut als Grundlage, aber es ist nicht notwendig.'
}, {
  q: 'Was ist, wenn ich nicht 60 Minuten pro Tag habe?',
  a: 'Das System ist flexibel. Du kannst es im eigenen Tempo machen. 60 Minuten pro Tag ist ideal, aber selbst 15-20 Minuten täglich werden dir Fortschritte bringen.'
}, {
  q: 'Gibt es Unterstützung, wenn ich steckenbleibe?',
  a: 'Ja. Du erhältst Zugang zu unserer SIGMA SMART™-Community und kannst per E-Mail Support kontaktieren: soporte.sigmasmart@gmail.com'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Häufig gestellte Fragen" className="bg-transparent" data-id="element-55" data-mp="2fuhawharh4ib">
      <div className="mx-auto max-w-3xl px-5 py-12" data-id="element-56" data-mp="2azk5dkcoxda6">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-57" data-mp="38lr9kt5313m0">
          ❓ Häufig gestellte Fragen
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-58" data-mp="33n7lam30nfqh">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-59" data-mp="2unt124dg01ef" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-60" data-mp="1n8o6625wnfsw">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-61" data-mp="7p72u8n65suj">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-62" data-mp="cggs384t2u5w" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-63" data-mp="hfjknt3ln7wz" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-64" data-mp="md1wbr90418o">
                  <div className="overflow-hidden" data-id="element-65" data-mp="vdqaqn2b43m3">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-66" data-mp="vcf7cocrwxvi">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}